import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import BranchForm from "./branchComponents/BranchForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import {
  useGetBranchDetailQuery,
  useUpdateBranchMutation,
} from "store/services/branchApi";

const BranchEditScreen = () => {
  const { id } = useParams();
  const { from } = useLocation().state || {};
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Branches", path: "/app/crm/branch/list" },
    from === "detail" && {
      title: "Branch Detail",
      path: `/app/crm/branch/${id}/detail`,
    },
    { title: "Edit Branch" },
  ].filter(Boolean);

  const { data: branchDetail, isLoading: loadingBranchDetail } =
    useGetBranchDetailQuery(id);
  const [updateBranch, { isLoading: updatingBranch }] =
    useUpdateBranchMutation();

  const handleBranchUpdate = async (data) => {
    try {
      await updateBranch({ ...data, id }).unwrap();
      navigate(from === "detail" ? breadcrumbs[1].path : breadcrumbs[0].path);
      toast.success("Branch successfully updated!");
    } catch (error) {
      toast.error("Branch update failed! " + error.data?.message);
    }
  };

  return (
    <BreadcrumbLayout
      loading={loadingBranchDetail || updatingBranch}
      breadcrumbs={breadcrumbs}
    >
      <BreadcrumbLayout.Paper>
        <BranchForm
          branchDetail={branchDetail}
          isBusy={loadingBranchDetail || updatingBranch}
          onSubmit={handleBranchUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default BranchEditScreen;
